module.exports = __webpack_public_path__ + "static/media/Rise and Shout.94609cd7.jpg";